import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import SET_LOCALE from './types';
export default _defineProperty({}, SET_LOCALE, function (state, payload) {
  var currentState = state;
  currentState.currentLocale = payload;
});